module.exports = __webpack_public_path__ + "img/home_sponsors.15951d0d.png";